import {app} from '../app';
import {TranslationService} from '../services/TranslationService';
import {ITranslationService} from '../services/TranslationService';
import {ISessionService} from '../services/SessionService';
import {LoggerService} from '../services/LoggerService';
import {LoggerKey} from '../services/LoggerService';
import {IBrowserControlService} from '../services/BrowserControlService';

export class FooterController {

    private rootScope:IRootScope;
    private http:ng.IHttpService;
    private location:ng.ILocationService;
    private document:ng.IDocumentService;
    private translationService:ITranslationService;
    private sessionService:ISessionService;
    private loggerService:LoggerService;
    private browserControlService:IBrowserControlService;

    public year:number;

    private isFullScreen:boolean = false;

    static $inject = [
        '$rootScope',
        '$http',
        '$location',
        '$document',
        'TranslationService',
        'SessionService',
        'LoggerService',
        'BrowserControlService'
    ];

    constructor($rootScope:IRootScope,
                $http:ng.IHttpService,
                $location:ng.ILocationService,
                $document:ng.IDocumentService,
                TranslationService:ITranslationService,
                SessionService:ISessionService,
                LoggerService:LoggerService,
                BrowserControlService:IBrowserControlService) {

        this.rootScope = $rootScope;
        this.http = $http;
        this.location = $location;
        this.document = $document;
        this.translationService = TranslationService;
        this.sessionService = SessionService;
        this.loggerService = LoggerService;
        this.browserControlService = BrowserControlService;

        this.year = (new Date()).getFullYear();

        this.document.on('webkitfullscreenchange mozfullscreenchange fullscreenchange MSFullscreenChange', () => {
            this.isFullScreen = this._isFullScreen();
            this.loggerService.log(LoggerKey.FullScreen, {value: this.isFullScreen});
        });
    }

    fullScreen() {
        let document = this.document[0];
        let html = angular.element('html')[0];
        if (this._isFullScreen()) {
            this.runPrefixMethod(document, 'CancelFullScreen');
            this.isFullScreen = false;
        } else {
            this.runPrefixMethod(html, 'RequestFullScreen');
            this.isFullScreen = true;
        }
    }

    leaveQuestionnaire() {
        this.sessionService.exitRedirect();
    }

    private _isFullScreen() {
        return this.runPrefixMethod(document, 'FullScreen') || this.runPrefixMethod(document, 'IsFullScreen');
    }

    private runPrefixMethod(obj, method) {
        var pfx = ['webkit', 'moz', 'ms', 'o', ''], p = 0, m, t;
        while (p < pfx.length && !obj[m]) {
            m = method;
            if (pfx[p] == '') {
                m = m.substr(0, 1).toLowerCase() + m.substr(1);
            }
            m = pfx[p] + m;
            t = typeof obj[m];
            if (t != 'undefined') {
                pfx = [pfx[p]];
                return (t == 'function' ? obj[m]() : obj[m]);
            }
            p++;
        }
    }
}

app.controller('FooterController', FooterController);
